<template>
  <div class="navigation-map">
    <iframe :src="mapUrl" height="100%" width="100%" title="Map" />
  </div>
</template>

<script>
export default {
  name: "NavigationMap",
  props: {
    mapUrl: { type: String, default: "" },
  },
  components: {
    //
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    //
  },
  computed: {},
};
</script>
